<template>
  <!-- 顶部购物车的商品item -->
  <div class="item">
    <div class="cover">
      <el-image fit="cover" :src="VUE_APP_RESOURCES_URL + getCover(data)">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div class="tag">{{ type[data.contentType] }}</div>
    <div class="info">
      <div class="title">{{ getTitle(data) }}</div>
      <div class="price">{{ getPrice(data) }}</div>
      <div class="type">
        {{ type2[data.contentType] || `${getMaterialType(data)}` }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shoppingCart-item",
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      VUE_APP_RESOURCES_URL: process.env.VUE_APP_RESOURCES_URL,
      type: {
        video: "视频",
        imgAndText: "图文",
        hdr: "HDR",
        show: "展映",
        works: "作品",
        materialVideo: "视频",
        music: "音频",
        picture: "图片",
        template: "模板",
        other: "其它",
      },
      type2: {
        video: "学院教程",
        imgAndText: "学院教程",
        hdr: "视频播放",
        show: "视频播放",
        works: "视频播放",
      },
      memberCover: {
        pro: "web/img/pro_member.png",
        pro: "web/img/adv_member.png",
        pro: "web/img/bns_member.png",
      },
    };
  },
  methods: {
    getCover(data) {
      if (data.memberType) {
        return this.memberCover[data.memberType];
      }
      let cover = data.cover;
      let isMaterial = data.material;
      if (isMaterial) {
        if (!data.material.cover) {
          data.material.video.resources.map((el) => {
            if (el.resourceName === "180") {
              cover = el.resourceKey;
            }
          });
        } else {
          cover = data.material.cover;
        }
      }
      return cover;
    },
    getPrice(data) {
      if (data.memberType) {
        const obj = {
          pro: "360.00",
          adv: "1380.00",
          bns: "3600.00",
        };
        return obj[data.memberType];
      }
      if (data.disPlayPrice !== undefined) {
        return (data.disPlayPrice / 100).toFixed(2);
      }
      // 素材价格
      // 视频素材
      // console.log("priceLevel", data.priceLevel);
      if (data.material && data.material.mworks) {
        if (data.priceLevel.toLocaleLowerCase().includes("transcode")) {
          return (
            data.material.mworks[`${data.priceLevel}Price`] / 100
          ).toFixed(2);
        }
        return (data.material[`${data.priceLevel}Price`] / 100).toFixed(2);
      }
      // 其它素材
      return (data.material[`${data.priceLevel}Price`] / 100).toFixed(2);
    },
    getTitle(data) {
      if (data.name) {
        return data.name;
      } else if (data.memberType) {
        const obj = {
          pro: "专业会员",
          adv: "高级会员",
          bns: "商业会员",
        };
        return obj[data.memberType];
      }
      return data.material.title;
    },
    getMaterialType(data) {
      if (!data.priceLevel) {
        return "会员";
      }
      if (
        data.priceLevel &&
        data.priceLevel.toLocaleLowerCase().includes("transcode")
      ) {
        return `素材转码${data.priceLevel.replace("transcode", "")}`;
      }
      return "素材源文件";
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  display: flex;
  width: 100%;
  height: 80px;
  .cover {
    width: 37%;
    // min-width: 37%;
    .el-image {
      height: 100%;
    }
  }
  .info {
    margin-left: -20px;
    width: 63%;
    font-size: 12px;
    .title {
      width: 220px;
      height: 28px;
      font-size: 14px;
      color: #333;
      font-weight: 700;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .price {
      height: 28px;
      color: #ff5156;
      font-weight: bold;
    }
    .price::before {
      content: "￥";
      color: #ff5156;
      font-weight: bold;
    }
    .type {
      height: 28px;
      color: #999;
    }
  }
}
.tag {
  position: relative;
  top: 10px;
  right: 124px;
  height: 20px;
  width: 32px;
  background: #ffffff;
  border-radius: 4px;
  color: #ff5156;
  padding: 2px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}
</style>